import { h, Component } from 'preact';
import Store from 'store/store';
import { isPlaceholder } from 'utils/data';
import { listErrors } from 'utils/errors';
import { showModal } from 'utils/modal';
import * as jsonPointer from 'utils/jsonPointer';
import { isPowsterEmployee } from 'utils/roles';
import { isFocusStudio } from 'utils/studioConfig';

import Button from 'components/button/button';
import Publish from 'components/publish/publish';
import Unpublish from 'components/unpublish/unpublish';
import DomainSetUp from 'components/domainSetUp/domainSetUp';

export default class PublishButton extends Component {
	constructor(props) {
		super(props);

		this.publish = this.publish.bind(this);
		this.unpublish = this.unpublish.bind(this);
		this.domainSetUp = this.domainSetUp.bind(this);
	}

	async publish() {
		await showModal(Publish, { path: this.props.path });
	}

	async unpublish() {
		await showModal(Unpublish, { path: this.props.path });
	}

	async domainSetUp() {
		await showModal(DomainSetUp, { path: this.props.path });
	}

	canPublish() {
		if (isFocusStudio()) return true; // Any Focus Features page can be published immediately
		const path = this.props.path;
		const parsedPath = jsonPointer.parse(path);
		if (parsedPath[0] !== 'movies') return true; // An non-movie page can be published immediately
		const data = jsonPointer.get(Store.get().data, path);
		if (isPlaceholder(data)) return true; // Any placeholder movie can be published immediately
		return data?.ready_state === 'prod';
	}

	render(props) {
		const text = props.children?.length ? props.children : 'Publish';

		// Show unpublish button only for powster employees, and only if the page is published
		const showUnpublish = props.allowUnpublish && isPowsterEmployee();
		const domainAdd = props.allowUnpublish && isPowsterEmployee();
		const additionalOptions = [
			showUnpublish && <Button text danger icon="delete" onClick={this.unpublish}>Unpublish page</Button>,
			domainAdd && <Button text icon="link" onClick={this.domainSetUp}>Add domain</Button>
		].filter(Boolean);

		const { errors } = listErrors(props.path);
		const hasErrors = errors?.length;

		const canPublish = this.canPublish();
		const disabled = props.disabled || !props.path || hasErrors || !canPublish;
		const title = !canPublish ? 'This movie is currently being built and cannot be published.' : null;

		return (
			<Button
				primary
				icon="rocket"
				dark={props.dark}
				disabled={disabled}
				title={title}
				onClick={this.publish}
			>
				{text}
				{!!additionalOptions.length && (
					<div popover="auto" id="editor-publish">
						{additionalOptions}
					</div>
				)}
			</Button>
		);
	}
}